import { useTranslation } from 'react-i18next';

export type MetaLang = 'am' | 'ru' | 'en';

/** Maps i18n language codes to Layout meta keys (`am` | `ru` | `en`). */
const META_LANG_KEYS: Record<string, MetaLang | undefined> = {
    am: 'am',
    hy: 'am',
    ru: 'ru',
    en: 'en',
};

export function useCurrentLang(): MetaLang {
    const { i18n } = useTranslation();
    const code = (i18n.language || 'am').split('-')[0];
    return META_LANG_KEYS[code] ?? 'am';
}
